import { escapeRegExp } from 'lodash';
import React, { ReactNode } from 'react';

export function highLightText(needle: string, haystack: string): ReactNode {
  const matcher = new RegExp('(.*?)(' + escapeRegExp(needle) + ')(.*)', 'i');
  const matches = haystack.match(matcher);

  if (matches === null) {
    return <span>{haystack}</span>;
  }

  return (
    <span>
      {matches[1]}
      <strong>{matches[2]}</strong>
      {matches[3]}
    </span>
  );
}
